import './Location.css'

import React, { useEffect, useRef, useState } from 'react'
import { Button, Form, Spinner } from 'react-bootstrap'
import { useSelector } from 'react-redux'

import successIcon from '../../../imgs/check.png'
import errorIcon from '../../../imgs/remove.png'
//icons
import warningIcon from '../../../imgs/warning.png'
import { getPackageByXlt, updatePackage } from '../../../services/packages'

export default function Location() {
  const { loggedUser } = useSelector(state => state.user)

  const [shelfSelected, setshelfSelected] = useState('')
  const [shelfArr, setshelfArr] = useState([])
  const [packageSelected, setpackageSelected] = useState('')
  //for modal:
  const [isLoading, setisLoading] = useState(false)
  const [isShowModal, setisShowModal] = useState(false)
  const [modalType, setmodalType] = useState('')
  const [modalMsg, setmodalMsg] = useState('')
  const [warehouse, setWarehouse] = useState('')
  //for confirming with scanning
  const [awaitingConfirmation, setAwaitingConfirmation] = useState(false)
  const [lastScannedXlt, setLastScannedXlt] = useState('')
  const [confirmationInput, setConfirmationInput] = useState('')
  const confirmationInputRef = useRef(null)

  useEffect(() => {
    if (window.location.href.includes('office')) {
      document.getElementById('enable-toolbar').style.display = 'none'
    }
    // setWarehouse("USA")
    setWarehouse(loggedUser.UserAttributes['custom:warehouse'])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //focus on confirmation input when modal opens
  useEffect(() => {
    if (awaitingConfirmation && confirmationInputRef.current) {
      setTimeout(() => {
        confirmationInputRef.current.focus()
      }, 100)
    }
  }, [awaitingConfirmation])

  const shelfInputHandler = async shelf => {
    switch (warehouse) {
      case 'GR':
        if (shelf.length < 7) return
        break
      case 'USA':
        if (shelf.length < 5) return
        break
      case 'UK':
        if (shelf.length < 7) return
        break
    }
    if (shelf[0] == 'X' && shelf[1] == 'L') {
      setshelfSelected('')
      setmodalType('error')
      setmodalMsg('Scan shelf, not package. / ')
      setisShowModal(true)
      return
    }

    setshelfSelected(shelf)
    setshelfArr(shelf.split('-'))
  }

  const packagesInputHandler = async pXlt => {
    if (pXlt.length != 12) return

    try {
      const p = await getPackageByXlt(pXlt)
      // console.log("packagesInputHandler - p:", p)

      setpackageSelected(p)
      setLastScannedXlt(pXlt)

      //check if package already has location
      if (p.warehouseLocation) {
        setmodalType('warning')
        setmodalMsg('Package has location! Do you want to replace it?')
        setisShowModal(true)
        setAwaitingConfirmation(true)
        setConfirmationInput('')
      } else {
        updateLocation(p)
      }
    } catch (error) {
      console.log('packagesInputHandler - error:', error)
      setmodalType('error')
      setmodalMsg(error)
      setisShowModal(true)
    }
  }

  const confirmationScanHandler = pXlt => {
    if (pXlt.length != 12) return

    if (pXlt === lastScannedXlt) {
      //confirm the replacement
      updateLocation(packageSelected)
      setAwaitingConfirmation(false)
      setLastScannedXlt('')
      setConfirmationInput('')
    } else {
      //show error - wrong package scanned
      setmodalType('error')
      setmodalMsg('Wrong package scanned. Please scan the same package again or use the Yes button.')
      setTimeout(() => {
        setmodalType('warning')
        setmodalMsg('Package has location! Do you want to replace it?')
        if (confirmationInputRef.current) {
          confirmationInputRef.current.focus()
        }
        setConfirmationInput('')
      }, 2000)
    }
  }

  const updateLocation = async p => {
    // console.log(packageSelected);
    let pToUse
    if (!p) pToUse = packageSelected
    else pToUse = p

    setisLoading(true)
    setmodalType('loader')
    if (!isShowModal) setisShowModal(true)

    try {
      await updatePackage(pToUse.id, {
        warehouseLocation: shelfArr,
      })
      // console.log('updateLocation - res', res)

      setmodalMsg(`Package updated!`)
      setisLoading(false)
      setpackageSelected('')

      setTimeout(() => {
        setisShowModal(false)
        setAwaitingConfirmation(false)
      }, 2000)
    } catch (err) {
      console.log('🚀 - updateLocation - err', err)
      setmodalType('error')
      setmodalMsg(err.response.data.message)
      setisLoading(false)
      setpackageSelected('')
      setAwaitingConfirmation(false)
    }
  }

  const closeModal = () => {
    setisShowModal(false)
    setAwaitingConfirmation(false)
    setLastScannedXlt('')
    setConfirmationInput('')
  }

  return (
    <section className='location-comp'>
      <h2>Location</h2>
      {!isShowModal ? (
        !shelfSelected ? (
          <div className='location-input-cont'>
            <div>Scan shelf</div>
            <Form.Control
              onChange={e => {
                shelfInputHandler(e.target.value)
              }}
              size='sm'
              autoFocus
            ></Form.Control>
          </div>
        ) : (
          <div>
            <h4>{shelfSelected}</h4>
            <div>
              <Button onClick={() => setshelfSelected('')} style={{ minWidth: 'max-content' }}>
                Change shelf
              </Button>
              <br />
              <br />
              <div>Scan packages</div>
              <Form.Control
                onChange={e => {
                  packagesInputHandler(e.target.value)
                }}
                size='sm'
                autoFocus
              ></Form.Control>
            </div>
          </div>
        )
      ) : (
        <div>
          <LocationModal
            type={modalType}
            msg={modalMsg}
            isLoading={isLoading}
            setisShowModal={closeModal}
            updateLocation={() => updateLocation()}
            awaitingConfirmation={awaitingConfirmation}
            confirmationInput={confirmationInput}
            setConfirmationInput={setConfirmationInput}
            confirmationScanHandler={confirmationScanHandler}
            confirmationInputRef={confirmationInputRef}
          />
        </div>
      )}
    </section>
  )
}

function LocationModal(props) {
  const {
    type,
    msg,
    setisShowModal,
    updateLocation,
    isLoading,
    awaitingConfirmation,
    confirmationInput,
    setConfirmationInput,
    confirmationScanHandler,
    confirmationInputRef,
  } = props

  const [imageSrc, setimageSrc] = useState('')
  const [title, setTitle] = useState('')
  const [text, setext] = useState('')

  useEffect(() => {
    switch (type) {
      case 'warning':
        setimageSrc(warningIcon)
        setTitle('Warning!')
        setext(msg)
        break
      case 'loader':
        setimageSrc(successIcon)
        setTitle('Success!')
        setext(msg)
        break
      case 'error':
        setimageSrc(errorIcon)
        setTitle('Error!')
        setext(msg)
        break
    }
  }, [type, msg, imageSrc])

  return (
    <section className='locationModal-comp'>
      {isLoading ? (
        <div style={{ marginTop: '10%', textAlign: 'center' }}>
          <Spinner animation='border' variant='primary' />
        </div>
      ) : (
        <div className='locationModal-comp-main'>
          <img src={imageSrc} />
          <h3>{title}</h3>
          <p>{text}</p>
          {type === 'warning' && awaitingConfirmation && (
            <div className='locationModal-comp-scan'>
              <p>Scan this package again to confirm or use the Yes button:</p>
              <Form.Control
                ref={confirmationInputRef}
                value={confirmationInput}
                onChange={e => {
                  setConfirmationInput(e.target.value)
                  if (e.target.value.length === 12) {
                    confirmationScanHandler(e.target.value)
                  }
                }}
                size='sm'
                autoFocus
              ></Form.Control>
            </div>
          )}
          {type === 'warning' && (
            <div className='locationModal-comp-actions'>
              <Button variant='danger' onClick={() => updateLocation()}>
                Yes
              </Button>
              <Button variant='danger' style={{ backgroundColor: '#e91d1d', borderColor: '#e91d1d' }} onClick={() => setisShowModal(false)}>
                Cancel
              </Button>
            </div>
          )}
          <br />
          <br />
          <Button style={{ backgroundColor: '#e91d1d', borderColor: '#e91d1d' }} onClick={() => setisShowModal(false)}>
            Back
          </Button>
        </div>
      )}
    </section>
  )
}
